module.exports = __webpack_public_path__ + "static/img/mouth.7d98f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mouth.png
// module id = hQ3T
// module chunks = 21